import { left, Either } from "fp-ts/lib/Either";

type EitherFunction = (...args: any) => Either<string[], any>;

export function catchAndLogExceptions<T extends EitherFunction>(func: T): T {
  return ((...args) => {
    try {
      return func(...args);
    } catch (e) {
      console.log(
        "[Breakdance - catchAndLogExceptions] an exception occurred in function: ",
        func
      );
      console.error(e);
      return left(["an exception occured, check the console"]);
    }
  }) as T;
}

/*
  Enclose external code we don't control in an IIFE (https://developer.mozilla.org/en-US/docs/Glossary/IIFE)
  to prevent polluting Global, Try/Catch the code and log errors in the script to the user.
  Use window.parent because it runs in the canvas iframe and not in the main window.
 */
export function inlineTryCatchIIFE(script: string, errorMessage: string) {
  const safeScript = script.replace(/`/g, "\\`").replace(/\$/g, "\\$");

  // we used to use the notification logger instead of console.warn, i.e.
  // window.parent.Breakdance.NotificationLogger.log.message(
  //   \`${errorMessage}. Error:"\${e}"\`
  // );
  // but there were too many annoying warnings in the UI for non-issues

  return `
      (function(){
        try {
          eval(\`${safeScript}\`);
        } catch (e) {
          console.warn(\`${errorMessage}\`);
          console.error(e);
        }
      })();
      `;
}
